// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#div_menu
{
    position: fixed;
    left: 0px;
    top: 0px;
    height: 64px;
    width: 100%;
    color: orange;
    background-color: black;
}

#div_content
{
    position: fixed;
    left: 0px;
    top: 64px;
    width: 100%;
    height: calc(100% - 96px);
    overflow-y:auto;
    color: black;
    background-color: white;
}

#div_footer
{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 32px;
    color: orange;
    background-color:  black;
}

#footer_text
{
    margin: 0px;
    text-align: left;
}

#img_passur
{
    position: fixed;
    bottom: 0px;
    right: 0px;
}

h2
{
    margin-left: 15px;
}

li
{
    margin-bottom: 15px;
    padding: 15px;
    color: gray;
    background-color: black;
    border: 1px solid gray;
    border-radius: 12px;
    width: 50px;
    text-align: center;
}

li > a
{
    color: orange;
    background-color: black;
    font-size: larger;
    font-weight: bold;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/page/Construct.css"],"names":[],"mappings":"AAAA;;IAEI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,SAAS;IACT,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,wBAAwB;AAC5B;;AAEA;;IAEI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,UAAU;AACd;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;AACzB","sourcesContent":["#div_menu\n{\n    position: fixed;\n    left: 0px;\n    top: 0px;\n    height: 64px;\n    width: 100%;\n    color: orange;\n    background-color: black;\n}\n\n#div_content\n{\n    position: fixed;\n    left: 0px;\n    top: 64px;\n    width: 100%;\n    height: calc(100% - 96px);\n    overflow-y:auto;\n    color: black;\n    background-color: white;\n}\n\n#div_footer\n{\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 32px;\n    color: orange;\n    background-color:  black;\n}\n\n#footer_text\n{\n    margin: 0px;\n    text-align: left;\n}\n\n#img_passur\n{\n    position: fixed;\n    bottom: 0px;\n    right: 0px;\n}\n\nh2\n{\n    margin-left: 15px;\n}\n\nli\n{\n    margin-bottom: 15px;\n    padding: 15px;\n    color: gray;\n    background-color: black;\n    border: 1px solid gray;\n    border-radius: 12px;\n    width: 50px;\n    text-align: center;\n}\n\nli > a\n{\n    color: orange;\n    background-color: black;\n    font-size: larger;\n    font-weight: bold;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
